import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-square-Import-lined",
  "use": "rt-base-square-Import-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-square-Import-lined\"><path d=\"M896.4 767.6h-56c-4.4 0-8 3.6-8 8V840H176.9V184h655.6v64.4c0 4.4 3.6 8 8 8h56c4.4 0 8-3.5 8-8V144c0-17.7-14.3-32-32-32H137c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h735.5c17.7 0 32-14.3 32-32V775.6c-0.1-4.4-3.7-8-8.1-8z\" /><path d=\"M910.7 474.5H583.8v-79.2c0-7-8.1-10.9-13.5-6.6L422.6 505.4c-4.3 3.3-4.3 9.8 0 13.1l147.7 116.7c5.5 4.4 13.5 0.4 13.5-6.6v-79.2h326.8c4.6 0 8.3-3.8 8.3-8.3v-58.3c0.1-4.5-3.6-8.3-8.2-8.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/square-Import-lined.svg
// module id = 1753
// module chunks = 228